import type { MultiFilterRow } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { AgeFilter } from '@pages/Clients/NewClientsList/ui/AgeFilter';
import { AgeSelected } from '@pages/Clients/NewClientsList/ui/AgeSelected';
import { BalanceFilter } from '@pages/Clients/NewClientsList/ui/BalanceFilter';
import { BalanceSelected } from '@pages/Clients/NewClientsList/ui/BalanceSelected';
import { BirthdayFilter } from '@pages/Clients/NewClientsList/ui/BirthdayFilter';
import { BirthdaySelected } from '@pages/Clients/NewClientsList/ui/BirthdaySelected';
import { ClientsTagsFilter } from '@pages/Clients/NewClientsList/ui/ClientsTagsFilter';
import { ClientsTagsSelected } from '@pages/Clients/NewClientsList/ui/ClientsTagsSelected';
import { EmployeeFilter } from '@pages/Clients/NewClientsList/ui/EmployeeFilter';
import { EmployeeSelected } from '@pages/Clients/NewClientsList/ui/EmployeeSelected';
import { GenderFilter } from '@pages/Clients/NewClientsList/ui/GenderFilter';
import { GenderSelected } from '@pages/Clients/NewClientsList/ui/GenderSelected';
import { HasLoyaltyCardFilter } from '@pages/Clients/NewClientsList/ui/HasLoyaltyCardFilter';
import { HasLoyaltyCardSelected } from '@pages/Clients/NewClientsList/ui/HasLoyaltyCardSelected';
import { HasRecordsFilter } from '@pages/Clients/NewClientsList/ui/HasRecordsFilter';
import { HasRecordsSelected } from '@pages/Clients/NewClientsList/ui/HasRecordsSelected';
import { HasTasksFilter } from '@pages/Clients/NewClientsList/ui/HasTasksFilter';
import { HasTasksSelected } from '@pages/Clients/NewClientsList/ui/HasTasksSelected';
import { PeriodFilter } from '@pages/Clients/NewClientsList/ui/PeriodFilter';
import { PeriodSelected } from '@pages/Clients/NewClientsList/ui/PeriodSelected';
import { RecordsCountFilter } from '@pages/Clients/NewClientsList/ui/RecordsCountFilter';
import { RecordsCountSelected } from '@pages/Clients/NewClientsList/ui/RecordsCountSelected';
import { RecordsStatusFilter } from '@pages/Clients/NewClientsList/ui/RecordsStatusFilter';
import { RecordsStatusSelected } from '@pages/Clients/NewClientsList/ui/RecordsStatusSelected';
import { RecordsTagsFilter } from '@pages/Clients/NewClientsList/ui/RecordsTagsFilter';
import { RecordsTagsSelected } from '@pages/Clients/NewClientsList/ui/RecordsTagsSelected';
import { ServiceCategoriesFilter } from '@pages/Clients/NewClientsList/ui/ServiceCategoriesFilter';
import { ServiceCategoriesSelected } from '@pages/Clients/NewClientsList/ui/ServiceCategoriesSelected';
import { ServicesFilter } from '@pages/Clients/NewClientsList/ui/ServicesFilter';
import { ServicesSelected } from '@pages/Clients/NewClientsList/ui/ServicesSelected';
import { ServicesSumFilter } from '@pages/Clients/NewClientsList/ui/ServicesSumFilter';
import { ServicesSumSelected } from '@pages/Clients/NewClientsList/ui/ServicesSumSelected';
import { SoldFilter } from '@pages/Clients/NewClientsList/ui/SoldFilter';
import { SoldSelected } from '@pages/Clients/NewClientsList/ui/SoldSelected';

const HasRecords = {
  Filter: HasRecordsFilter,
  Selected: HasRecordsSelected,
};

const Period = {
  Filter: PeriodFilter,
  Selected: PeriodSelected,
};

const Employee = {
  Filter: EmployeeFilter,
  Selected: EmployeeSelected,
};

const Services = {
  Filter: ServicesFilter,
  Selected: ServicesSelected,
};

const ServiceCategories = {
  Filter: ServiceCategoriesFilter,
  Selected: ServiceCategoriesSelected,
};

const ServicesSum = {
  Filter: ServicesSumFilter,
  Selected: ServicesSumSelected,
};

const RecordsCount = {
  Filter: RecordsCountFilter,
  Selected: RecordsCountSelected,
};

const RecordsStatus = {
  Filter: RecordsStatusFilter,
  Selected: RecordsStatusSelected,
};

const RecordsTags = {
  Filter: RecordsTagsFilter,
  Selected: RecordsTagsSelected,
};

const Gender = {
  Filter: GenderFilter,
  Selected: GenderSelected,
};

const ClientTags = {
  Filter: ClientsTagsFilter,
  Selected: ClientsTagsSelected,
};

const Sold = {
  Filter: SoldFilter,
  Selected: SoldSelected,
};

const Birthday = {
  Filter: BirthdayFilter,
  Selected: BirthdaySelected,
};

const Age = {
  Filter: AgeFilter,
  Selected: AgeSelected,
};

const Balance = {
  Filter: BalanceFilter,
  Selected: BalanceSelected,
};

const HasTasks = {
  Filter: HasTasksFilter,
  Selected: HasTasksSelected,
};

const HasLoyaltyCard = {
  Filter: HasLoyaltyCardFilter,
  Selected: HasLoyaltyCardSelected,
};

export const VISIT_ROWS: MultiFilterRow[] = [
  {
    id: 'has-records',
    label: 'Наличие записей',
    BottomContent: HasRecords.Selected,
    Content: HasRecords.Filter,
  },
  {
    id: 'records-status',
    label: 'Статус записей',
    BottomContent: RecordsStatus.Selected,
    Content: RecordsStatus.Filter,
  },
  {
    id: 'records-count',
    label: 'Количество записей',
    BottomContent: RecordsCount.Selected,
    Content: RecordsCount.Filter,
  },
  {
    id: 'records-tags',
    label: 'Теги записей',
    BottomContent: RecordsTags.Selected,
    Content: RecordsTags.Filter,
  },
  {
    id: 'period',
    label: 'Период',
    BottomContent: Period.Selected,
    Content: Period.Filter,
  },
  {
    id: 'employee',
    label: 'Исполнитель',
    BottomContent: Employee.Selected,
    Content: Employee.Filter,
  },
  {
    id: 'services',
    label: 'Услуги',
    BottomContent: Services.Selected,
    Content: Services.Filter,
  },
  {
    id: 'service-categories',
    label: 'Категории услуг',
    BottomContent: ServiceCategories.Selected,
    Content: ServiceCategories.Filter,
  },
  {
    id: 'services-sum',
    label: 'Сумма оказанных услуг',
    BottomContent: ServicesSum.Selected,
    Content: ServicesSum.Filter,
  },
];

export const CLIENT_ROWS: MultiFilterRow[] = [
  {
    id: 'gender',
    label: 'Пол',
    BottomContent: Gender.Selected,
    Content: Gender.Filter,
  },
  {
    id: 'client-tags',
    label: 'Теги клиентов',
    BottomContent: ClientTags.Selected,
    Content: ClientTags.Filter,
  },
  {
    id: 'sold',
    label: 'Продано',
    BottomContent: Sold.Selected,
    Content: Sold.Filter,
  },
  {
    id: 'birthday',
    label: 'День рождения',
    BottomContent: Birthday.Selected,
    Content: Birthday.Filter,
  },
  {
    id: 'age',
    label: 'Возраст',
    BottomContent: Age.Selected,
    Content: Age.Filter,
  },
  {
    id: 'balance',
    label: 'Баланс',
    BottomContent: Balance.Selected,
    Content: Balance.Filter,
  },
  {
    id: 'has-tasks',
    label: 'Наличие задач',
    BottomContent: HasTasks.Selected,
    Content: HasTasks.Filter,
  },
  {
    id: 'has-loyalty-card',
    label: 'Наличие карты лояльности',
    BottomContent: HasLoyaltyCard.Selected,
    Content: HasLoyaltyCard.Filter,
  },
];
